import React, { Component } from 'react';
import { Button, Icon, Form, Segment } from 'semantic-ui-react';
import ConsumerInfo from './ConsumerInfo';
import ReactTable from 'react-table';
class Batch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showHide: [],
            acsDeleted: [],
        };
    }
    addToDeleteList = (index, acsAccountId) => {
        let acsDeleted = this.state.acsDeleted.slice();
        acsDeleted[index] = (!acsDeleted.hasOwnProperty(index)) ? true : !acsDeleted[index];
        this.setState({ acsDeleted }, () => { this.props.checkedItemsForDelete(acsAccountId, acsDeleted[index]) });
    }

    componentDidUpdate(prevProps) {
        if (this.props.batch !== prevProps.batch) {
            this.setState({ acsDeleted: [] });
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        // eslint-disable-next-line
        if ((this.props.batch !== nextProps.batch) || this.state != nextState) {
            return true;
        }
        return false;
    }

    render() {
        return (
            <div className="table-responsive">
                <ReactTable noDataText={null} minRows={0} defaultPageSize={this.props.reactTable().pageSize} showPagination={this.props.batch && this.props.batch.length > this.props.reactTable().pageSize ? true : false} filterable defaultFilterMethod={this.props._customFilter} className="celled -striped -highlight "
                    data={this.props.batch}
                    getNoDataProps={() => {
                        return { style: { display: 'none' } };
                    }}

                    columns={[{
                        expander: true,
                        Header: props => <span data-inverted=""
                            data-tooltip={this.props.t("view.account.details")}
                            data-position="bottom left">#
                        </span>,
                        Expander: ({ isExpanded, ...rest }) =>
                            <div>
                                {
                                    isExpanded
                                        ? <Icon className="arrow alternate circle down icon"></Icon>
                                        : <Icon className="arrow alternate circle right icon"></Icon>
                                }
                            </div>,
                        style: {
                            cursor: "pointer"
                        }
                    }, {
                        Header: props => <span data-inverted="" data-tooltip={this.props.t("client.account.tooltip")} data-position="bottom left">{this.props.t("client.account")}</span>,
                        accessor: 'acsClientId',
                    }, {
                        Header: props => <span data-inverted="" data-tooltip={this.props.t("consumer.lname.tooltip")} data-position="bottom left">{this.props.t("lastname")}</span>,
                        accessor: 'consumer.acsConsumerLastName',
                    }, {
                        Header: props => <span data-inverted="" data-tooltip={this.props.t("consumer.fname.tootip")} data-position="bottom left">{this.props.t("firstname")}</span>,
                        accessor: 'consumer.acsConsumerFirstName',
                    }, {
                        Header: props => <span data-inverted="" data-tooltip={this.props.t("service.provided")} data-position="bottom right">{this.props.t("account.for")}</span>,
                        accessor: 'acsAccountFor',
                    }, {
                        Header: props => <span data-inverted="" data-tooltip={this.props.t("date.of.last.payment.tooltip")} data-position="bottom right">{this.props.t("date.of.last.payment")}</span>,
                        accessor: 'acsLastPaymentDate',
                    }, {
                        Header: props => <span data-inverted="" data-tooltip={this.props.t("service.start.date.tooltip")} data-position="bottom right">{this.props.t("service.start.date")}</span>,
                        id: 'acsServiceStartDate',
                        accessor: 'acsServiceStartDate',
                        //accessor: row => (
                          //  this.props._formatDate(row.acsLastPaymentDate)
                       // )
                    }, {
                        Header: props => <span data-inverted="" data-tooltip={this.props.t("service.end.tooltip")} data-position="bottom right">{this.props.t("service.end")}</span>,
                        id: 'acsServiceEndDate',
                        accessor: 'acsServiceEndDate',
                      //  accessor: row => (
                      //      this.props._formatDate(row.acsServiceEndDate)
                      //  )
                    },
                    {
                        Header: props => <span data-inverted="" data-tooltip={this.props.t("first.billing.date.tooltip")} data-position="bottom right">{this.props.t("first.billing")}</span>,
                        id: 'acsFirstBillingDate',
                        accessor: 'acsFirstBillingDate'
                        //accessor: row => (
                       //     this.props._formatDate(row.acsFirstBillingDate)
                       // )
                    },

                    {
                        Header: props => <span data-inverted="" data-tooltip={this.props.t("principal.balance.placeholder")} data-position="bottom right">{this.props.t("principal.balance.batch")}</span>,
                        id: 'acsPrincipalReferred',
                        accessor: row => (
                            this.props._currencyFormat(row.acsPrincipalReferred)
                        )
                    }, {
                        Header: props => <span data-inverted="" data-tooltip={this.props.t("interest.tooltip")} data-position="bottom right">{this.props.t("interest")}</span>,
                        id: 'acsInterestReferred',
                        accessor: row => (
                            this.props._currencyFormat(row.acsInterestReferred)
                        )
                    }, {
                        Header: props => <span data-inverted="" data-tooltip={this.props.t("other.charges.tooltip")} data-position="bottom right">{this.props.t("other.charges")}</span>,
                        id: 'acsOtherReferred',
                        accessor: row => (
                            this.props._currencyFormat(row.acsOtherReferred)
                        )
                    }, {
                        Header: props => <span data-inverted="" data-tooltip={this.props.t("total.tooltip")} data-position="bottom right">{this.props.t("total")}</span>,
                        id: 'acsTotalReferred',
                        accessor: row => (
                            this.props._currencyFormat(row.acsTotalReferred)
                        )
                    }, {
                        Header: props => <span data-inverted="" data-tooltip={this.props.t("click.action.buttons")} data-position="bottom right">{this.props.t("actions")}</span>,
                        filterable: false,
                        Cell: row => (
                            <Button href={"#account"} onClick={() => { this.props.updateBatch(this.props.batch[row.index]) }} className="ui icon mini button" data-inverted="" data-tooltip={this.props.t("edit.tooltip")} data-position="top right">
                                <Icon name="pencil" />
                            </Button>
                        )
                    },
                    {
                        Header: props => <span data-inverted="" data-tooltip={this.props.t("delete.tooltip")} data-position="bottom right">{this.props.t("delete")}</span>,
                        filterable: false,
                        Cell: row => (
                            <Form.Checkbox checked={this.state.acsDeleted[row.index] === true ? true : false} onClick={() => { this.addToDeleteList(row.index, row.original.acsAccountId) }} />
                        )
                    }]}
                    onExpandedChange={(expanded, index, event) => {
                        this.setState({ expanded });
                    }}
                    expanded={this.state.expanded}
                    SubComponent={row => {
                        return (
                            <div style={{ padding: 10 }}>
                                <ConsumerInfo title={this.props.t("primary.responsible.party")} consumer={row.original.consumer} busniessType={row.original.busniessType} {...this.props} />
                                {
                                    (() => {
                                        if (row.original.consumer.secondaryConsumers != null && row.original.consumer.secondaryConsumers instanceof Array) {
                                            return row.original.consumer.secondaryConsumers.map((secConsumer, secConsumerIndex) => {
                                                return (
                                                    <ConsumerInfo title={this.props.t("secondary.responsible.party") + " [" + (secConsumerIndex + 1) + "]"} key={secConsumerIndex} consumer={secConsumer} busniessType={row.original.busniessType} {...this.props} />
                                                )
                                            })
                                        }
                                    }
                                    )()
                                }
                                <Segment attached='top' color="red">{this.props.t("comments")} <br /> {row.original.acsComments}</Segment>
                            </div>
                        )
                    }}
                />
            </div>

        )
    }
}
export default Batch;


// WEBPACK FOOTER //
// ./src/app/ui/accounts/Batch.js